'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _recompose = require('recompose');

var _Button = require('../../../../components/buttons/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Icon = require('../../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Spinner = require('../../../../components/loaders/Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

var _exportPopupActions = require('./exportPopupActions');

var _analytics = require('../../../../analytics');

var _exportConstants = require('./exportConstants');

require('./ExportPopupButton.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var exportButtonSelector = (0, _reselect.createSelector)(function (state, ownProps) {
    return state.getIn(['app', 'popup', 'exporting', ownProps.format]);
}, function (buttonState) {
    return {
        fetching: buttonState === _exportConstants.EXPORT_BOARD_STATES.FETCHING,
        fetched: buttonState && buttonState !== _exportConstants.EXPORT_BOARD_STATES.FETCHING && buttonState !== _exportConstants.EXPORT_BOARD_STATES.FAILED,
        url: buttonState
    };
});

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchExportBoard: function dispatchExportBoard(_ref) {
            var boardId = _ref.boardId,
                format = _ref.format;
            return dispatch((0, _exportPopupActions.exportBoard)({ boardId: boardId, format: format }));
        }
    };
};

var exportButtonHandlers = {
    handleButtonClick: function handleButtonClick(props) {
        return function () {
            var dispatchExportBoard = props.dispatchExportBoard,
                fetching = props.fetching,
                fetched = props.fetched,
                url = props.url,
                currentBoardId = props.currentBoardId,
                format = props.format;


            if (fetched && url) return (0, _exportPopupActions.triggerDownload)(url);

            (0, _analytics.analyticsEvent)('exported-board-' + format);

            if (!fetching) return dispatchExportBoard({ boardId: currentBoardId, format: format });
        };
    }
};

var ExportPopupButton = function ExportPopupButton(props) {
    var iconName = props.iconName,
        title = props.title,
        handleButtonClick = props.handleButtonClick,
        className = props.className,
        fetching = props.fetching,
        fetched = props.fetched;


    return _react2.default.createElement(
        _Button2.default,
        { onClickFn: handleButtonClick, className: (0, _classnames2.default)('ExportPopupButton', className) },
        _react2.default.createElement(
            'div',
            { className: 'export-button-content' },
            _react2.default.createElement(
                'div',
                { className: 'left' },
                _react2.default.createElement(
                    'div',
                    { className: 'icon' },
                    _react2.default.createElement(_Icon2.default, { name: iconName })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'title' },
                    title
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'right' },
                fetching ? _react2.default.createElement(
                    'div',
                    { className: 'fetching' },
                    _react2.default.createElement(_Spinner2.default, { show: true }),
                    ' ',
                    _react2.default.createElement(
                        'span',
                        null,
                        'Generating'
                    )
                ) : null,
                fetched ? _react2.default.createElement(
                    'div',
                    { className: 'download' },
                    'Download'
                ) : null
            )
        )
    );
};

ExportPopupButton.propTypes = {
    iconName: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string.isRequired,
    format: _propTypes2.default.string.isRequired,
    currentBoardId: _propTypes2.default.string.isRequired,
    className: _propTypes2.default.string,
    fetching: _propTypes2.default.bool,
    fetched: _propTypes2.default.bool,
    url: _propTypes2.default.string,
    dispatchExportBoard: _propTypes2.default.func,
    handleButtonClick: _propTypes2.default.func
};

var enhance = (0, _recompose.compose)((0, _reactRedux.connect)(exportButtonSelector, mapDispatchToProps), (0, _recompose.withHandlers)(exportButtonHandlers));

exports.default = enhance(ExportPopupButton);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/export/ExportPopupButton.js
// module id = 2177
// module chunks = 0